import { createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { makeRequest } from "../../utils/request";
import { createRestSlice, ItemState } from "./restSlice";

export type BugTicket = {
  id: string;
  userId: string;
  title: string;
  description: string;
  source: "web" | "cli";
  status: "open" | "in_progress" | "resolved" | "closed";
  screenshotUrl?: string;
  cliVersion?: string;
  osInfo?: string;
  createdAt: Date;
  updatedAt: Date;
};

export type CreateBugTicketRequest = {
  title: string;
  description: string;
  screenshotUrl?: string;
};

const submitBugTicket = createAsyncThunk("bugTicket/submit", async (payload: CreateBugTicketRequest, { rejectWithValue }) => {
  try {
    const { data } = await makeRequest<{ data: BugTicket }>("/v1/bug-tickets", {
      method: "POST",
      body: {
        ...payload,
        source: "web",
      },
    });
    return data;
  } catch (error: any) {
    return rejectWithValue(error.message || "Failed to submit bug report");
  }
});

const bugTicketSlice = createRestSlice<BugTicket>("bugTickets", "/v1/bug-tickets", {
  extraReducers: (builder) => {
    builder
      .addCase(submitBugTicket.pending, (state: ItemState<BugTicket>) => {
        state.isLoadingCreate = true;
      })
      .addCase(submitBugTicket.fulfilled, (state: ItemState<BugTicket>, action: PayloadAction<BugTicket>) => {
        state.isLoadingCreate = false;
        state.entities[action.payload.id] = action.payload;
        state.ids.push(action.payload.id);
      })
      .addCase(submitBugTicket.rejected, (state: ItemState<BugTicket>) => {
        state.isLoadingCreate = false;
      });
  },
});

export const bugTicketReducer = bugTicketSlice.reducer;
export const bugTicketActions = {
  ...bugTicketSlice.actions,
  submitBugTicket,
};
